import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";

export class OnHoldBookingContext {
    public routeTo: string[] = [];
    public actionResult: Partial<IDefaultActionResult> = {}

    constructor() {

    }
}